import { types, Instance } from 'mobx-state-tree';

import { SimpleResourcesModel } from './SimpleResourcesModel';
import { BoardsModel } from './BoardModel';
import { OuterThemesModel } from './ThemesModel';

export const ResourcesStore = types.compose(SimpleResourcesModel, OuterThemesModel, BoardsModel).views(self => ({
  get isFetching() {
    return self.simpleResourceIsFetching + self.themesIsFetching + self.boardsIsFetching;
  }
}));
export type IResourcesStore = Instance<typeof ResourcesStore>;
